import { ProDetailList } from '@bedrock/eed-react';
import {
  FormCard,
  FormItemAddressDetail,
  FormItemContactsDetailList,
  FormItemContactType,
  FormItemPersonEmail,
  FormItemPersonName,
  FormItemPhoneNumber,
  FormItemPopoNumber,
  FormItemPositionName,
  FormItemWeChat,
  FormModule,
} from '@purchase/supplier';
import React, { useMemo } from 'react';
import { get } from 'lodash-es';
import { ProTextEllipsis } from '../../components/ProTextEllipsis';

const ContactInfo = (props: {
  namePath?: string[];
  mode?: 'card' | 'module';
  formDetail?: any;
}) => {
  const { namePath = [], mode = 'card', formDetail } = props;
  const Wrapper = mode === 'card' ? FormCard : FormModule;
  const contactCount = useMemo(
    () => get(formDetail, [...namePath, 'vendorContacts'])?.length ?? 0,
    [formDetail, namePath]
  );
  return (
    <Wrapper
      title="联系人信息"
      titleCount={contactCount}
      proCardProps={{ expandable: true, defaultExpanded: contactCount > 0 }}
    >
      <FormItemContactsDetailList name={[...namePath, 'vendorContacts']}>
        <ProDetailList.Item
          label="#"
          name="#"
          meta={{ columnProps: { width: 50, fixed: true } }}
        >
          {(value, record, index) => {
            return index + 1;
          }}
        </ProDetailList.Item>
        <FormItemContactType
          label="联系人类型"
          name="contactType"
          meta={{
            columnProps: { width: 200, className: 'font-bold', fixed: true },
          }}
        />
        <FormItemPersonName
          label="姓名"
          name="name"
          meta={{ columnProps: { width: 160 } }}
        />
        <FormItemPositionName
          label="职务"
          name="post"
          meta={{ columnProps: { width: 160 } }}
        />
        <FormItemPersonEmail
          label="邮箱"
          name="mail"
          meta={{ columnProps: { width: 240 } }}
        />
        <FormItemPhoneNumber
          label="联系电话"
          name="phone"
          meta={{ columnProps: { width: 160 } }}
        />
        <FormItemPopoNumber
          label="POPO账号"
          name="popoAccount"
          meta={{ columnProps: { width: 200 } }}
        />
        <FormItemWeChat
          label="微信号"
          name="weChat"
          meta={{ columnProps: { width: 200 } }}
        />
        <ProTextEllipsis
          label="MPC账号"
          name="externalBusinessAccount"
          meta={{ columnProps: { width: 200 } }}
        />
        <FormItemAddressDetail
          label="联系地址"
          name="address"
          meta={{ columnProps: { width: 200 } }}
        />
      </FormItemContactsDetailList>
    </Wrapper>
  );
};

export default ContactInfo;
